<template>
    <div class="button green px-8px" @click="showModal = true">
        <span class="material-icons valign-middle text-23px">settings</span>

        <Modal v-if="showModal" @closeClicked="hideModal">
            <template v-slot:header>
                <h1 class="text-17px font-medium">Table settings</h1>
            </template>

            <template v-slot:body>
                <p class="font-medium mb-5px">Columns</p>
                <div v-for="(colSettings, column) in columnsWithSettings" :key="column" class="mb-5px">
                    <span class="ml-10px">
                        <span class="material-icons valign-middle text-grey-light text-17px cursor-help mr-10px">help</span>
                        <Tooltip v-if="colSettings.info">{{ colSettings.info }}</Tooltip>
                    </span>
                    <input type="checkbox" :id="`chk_${column}`" class="valign-middle cursor-pointer" :value="column" v-model="checkedColumns">
                    <label :for="`chk_${column}`" class="cursor-pointer"> {{ colSettings.title }}</label>
                </div>

                <p class="font-medium mb-5px mt-20px">Advanced</p>
                <div>
                    <input type="checkbox" id="showsolditems" v-model="showSoldItems" class="valign-middle cursor-pointer">
                    <label for="showsolditems" class="cursor-pointer"> Show sold items</label>
                </div>
            </template>

            <template v-slot:footer>
                <div class="buttons text-right">
                    <div class="button green" @click="hideModal">Ok</div>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script>
import Modal from '@/components/global/Modal'
import Tooltip from '@/components/global/Tooltip'
import portfolioColumns from '@/services/portfolioColumns'

export default {
    components: { Modal, Tooltip },
    data(){
        return{
            columnsWithSettings: portfolioColumns.columnsWithSettings,
            checkedColumns: portfolioColumns.visibleColumns,
            showModal: false,
        }
    },
    watch:{
        checkedColumns(){
            portfolioColumns.setVisibleColumns(this.checkedColumns)
        },
    },
    computed:{
        showSoldItems:{
            get(){
                return portfolioColumns.showSoldItems
            },
            set(value){
                portfolioColumns.showSoldItems = value
            }
        }
    },
    methods:{
        hideModal(){
            this.showModal = false
        },
    }
}
</script>